import {Dialog} from './dialog';
import {DialogOptions} from './dialogController';

export class DialogWithInput<DialogInput, R> {
    readonly input: DialogInput;
    readonly options: DialogOptions;
    readonly dialog: Dialog<R>;

    constructor(input: DialogInput,
                options: DialogOptions,
                dialog: Dialog<R>) {
        this.input = input;
        this.dialog = dialog;
        this.options = options;
    }
    close(dialogResult?: R): void {
        console.log('first close', dialogResult);
        this.dialog.close(dialogResult);
    }
}
